import { TypeItems } from '@/models/TypeItems';
import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { TypeState } from './Types';

export const getters: GetterTree<TypeState, RootState> = {
    getTypeList(state): TypeItems[] {
        return state.types;
    }
};
